export const riskKeys = {
  all: ["risk"] as const,
  project: (projectId: string, variantId: string) => [...riskKeys.all, projectId, variantId] as const,
  details: (riskId: string, variantId: string) => [...riskKeys.all, "details", riskId, variantId] as const,
  calculated: (projectId: string, variantId: string) => [...riskKeys.all, "calculated", projectId, variantId] as const,
  categories: (projectId: string) => [...riskKeys.all, "categories", projectId] as const,
};
